import datepopup from './components/datepopup';
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

function install (Vue) {
  Vue.component(datepopup.name, datepopup)
}


export default {
  install,
  datepopup,
};


// WEBPACK FOOTER //
// ./src/index.js